import { TabList } from "@mui/lab";
import { AppBar, Tab } from "@mui/material";
import { styled } from "@mui/styles"
import COLORS from "../../../../../theme/Colors";
import FONTS_FAMILY from "../../../../../theme/FontsFamily";
import CloseIcon from '@mui/icons-material/Close';

export const Header = styled('div')({
    flexGrow: 1,
    backgroundColor: COLORS.secondary,
});

export const Container = styled('div')({
    textAlign: 'center'
});

export const Title = styled('h1')({
    fontSize: '14px'
});

export const StyledTabList = styled(TabList)({
    '&.MuiTabs-root': {
        '&.MuiTabs-indicator': {
            'backgroundColor': `${COLORS.primary} !important`
        },
    },
    '&.MuiTabs-indicator': {
        'backgroundColor': `${COLORS.primary} !important`
    },
});

export const StyledTab = styled((props) => <Tab disableRipple {...props} />)(
    ({ theme }) => ({
        textTransform: 'none',
        fontSize: '20px',
        fontFamily: FONTS_FAMILY.medium.body,
        fontWeight: 'bold',
        marginRight: '5px',
        color: COLORS.grayPlaceholder,
        // backgroundColor:COLORS.snow,
        // borderRadius:'30px',
        '&:hover': {
            color: COLORS.white,
            backgroundColor: COLORS.secondary,
            borderBottom: `5px solid${COLORS.primary} `
        },
        '&.Mui-selected': {
            color: COLORS.white,
            backgroundColor: COLORS.secondary,
            borderBottom: `5px solid${COLORS.primary} `
        },
        '&.Mui-focusVisible': {
            backgroundColor: COLORS.primary
        },
    }),
);

export const RequestContainer = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  //  minHeight: '77vh',
    position: 'relative',
    alignSelf: 'center',
    justifyContent: 'center',
    alignItems: 'center'
});

export const PricesContainer = styled('div')(props =>({
    zIndex:9999999,
    backgroundColor:COLORS.white,
    display: 'flex',
    flexDirection: 'column',
    minHeight:'500px',
    height: '100%',
    width: '100%',
    alignSelf: 'center',
    alignItems: 'center',
    justifyContent: 'center'
}));

export const PricesItemContainer = styled('div')({
    display: 'flex',
    width: '100%',
    justifyContent: 'center'
});

export const StyledCloseIcon = styled(CloseIcon)({
    color: COLORS.black,
    '@media (min-width:320px)': {
        fontSize: '18px',
    },
    '@media (min-width:768px)': {
        fontSize: '20px',
    },
    '@media (min-width:1200px)': {
        fontSize: '30px',
    }
});